module.exports = __webpack_public_path__ + "static/media/imglogin.52d195df.svg";